/**
 * MJ — exclusive accordion rows.
 *
 * `<details name="...">` does this natively: opening one closes the rest, and
 * the closing animation is the same plain CSS transition as the opening one.
 * This only covers browsers where the attribute is not yet supported, so the
 * behaviour is identical everywhere.
 *
 * `toggle` does not bubble, hence the capture phase on the document — which
 * also means rows added later by a section re-render are picked up with no
 * re-initialising.
 */
(function () {
  if (window.__mjAccordion) return;
  window.__mjAccordion = true;

  // Nothing to do where the browser enforces the group itself.
  if ('name' in document.createElement('details')) return;

  document.addEventListener(
    'toggle',
    function (event) {
      var opened = event.target;
      if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
      if (!opened.classList.contains('mj-ac')) return;

      var group = opened.getAttribute('name');
      if (!group) return;

      var rows = document.querySelectorAll('details.mj-ac[name="' + group.replace(/"/g, '\\"') + '"]');
      for (var i = 0; i < rows.length; i += 1) {
        if (rows[i] !== opened) rows[i].open = false;
      }
    },
    true
  );
})();
